import { Observable } from "rxjs";
import { ConfigService } from "../services/config.service";

/**
 * Retrieves app configuration before the rest of the app loads
 */
export const initializeAppFactory = (configService: ConfigService): (() => Observable<boolean>) => {
    return () => configService.getConfig();
};
